/** 일일 충전/구매 한도 (만원 단위) */
export const DAILY_MAX_MAN = 20;
export const ENCOFFEE_DAILY_MAX_MAN = 10;

/** 카드 최대 잔액 (원) */
export const MAX_BALANCE_WON = 500_000;
